import { ActionType, BaseAction, ActionUpdateLayerData, SensorNodeStatus, EventReport } from '../../util/model';

interface State {
    status: SensorNodeStatus;
    report: EventReport;
}

const intitialState: State = {
    status: {
        Time: '',
        SensorNodes: [],
        SensorNodeStatus: []
    },
    report: {
        Time: '',
        SensorNodes: [],
        L1: [],
        L2: []
    }
}

export const layerDataReducer = (state: State = intitialState, action: BaseAction): State => {
    if (action.type === ActionType.UDPATE_LAYER_DATA) {
        const a = action as ActionUpdateLayerData;
        return {
            ...state,
            [a.payload.dataName]: a.payload.data
        }
    }
    return state;
}
